/**
 * Creates unique titles from program level and field of study
 */
const createUniqueTitles = (programs) => {
    const titles = new Set();
    programs.forEach(program => {
        const level = (program.programLevelName ?? '').trim();
        const fos = program.otherFieldOfStudy || program.fieldOfStudyName || '';
        let title = '';
        if (level && fos) {
            title = `${pluralizeLevel(level)}: ${fos}`;
        }
        else if (level) {
            title = pluralizeLevel(level);
        }
        else if (fos) {
            title = fos;
        }
        if (title)
            titles.add(title);
    });
    return Array.from(titles);
};
/**
 * Pluralizes program level names that don't end with 's'
 */
const pluralizeLevel = (level) => {
    return level.endsWith('s') ? level : `${level}s`;
};
/**
 * Joins levels with appropriate punctuation based on count
 * If there is only one level, return it
 * If there are two levels, join them with an ampersand
 * If there are more than two levels, join all but the last with a comma, then join the last with an ampersand
 */
const joinLevels = (levels) => {
    if (levels.length === 1)
        return levels[0];
    if (levels.length === 2)
        return levels.join(' & ');
    const allButLast = levels.slice(0, -1).join(', ');
    const last = levels[levels.length - 1];
    return `${allButLast} & ${last}`;
};
/**
 * Generates a formatted title from program data
 */
export const generateFundingCardTitle = (programs) => {
    const titles = createUniqueTitles(programs);
    return joinLevels(titles);
};
